function safe(s) {
  return s == null ? '' : String(s);
}

/**
 * Etiqueta Contract No.: id_pi, o siglas + correlativo-año (misma regla que packing list).
 * Sin fallback a "PI #id".
 */
export function proformaContractLabel(pi, clientes = []) {
  if (!pi) return '';
  const idPi = pi.id_pi != null && String(pi.id_pi).trim();
  if (idPi) return String(idPi);

  const cliente = (clientes || []).find((c) => String(c.id_cliente) === String(pi.cliente));
  const siglas = safe(cliente?.siglas).trim();
  const corrNum = pi.correlativo != null ? parseInt(pi.correlativo, 10) : NaN;
  const corr = Number.isFinite(corrNum) && corrNum >= 0 ? String(corrNum).padStart(2, '0') : '';
  const year = pi.fecha_embarque ? new Date(pi.fecha_embarque).getUTCFullYear() : null;
  const yy = Number.isFinite(year) ? String(year).slice(-2) : '';
  if (siglas && corr && yy) return `${siglas} ${corr}-${yy}`;
  if (corr) return siglas ? `${siglas} ${corr}` : corr;
  if (pi.id_proforma) return `PI ${pi.id_proforma}`;
  return '';
}

/** Etiquetas Contract No. de todas las PIs seleccionadas (orden del packing list). */
export function contractNoFromProformas(proformas, idProformas, clientes = []) {
  return (idProformas || [])
    .map((id) => (proformas || []).find((p) => String(p.id_proforma) === String(id)))
    .filter(Boolean)
    .map((pi) => proformaContractLabel(pi, clientes))
    .filter(Boolean)
    .join('; ');
}
